import { useEffect, useState } from "preact/hooks";
import fetchProduct, { getCachedProduct } from "./fetchProduct";

/**
 *
 * @param {tag|gid} id product id `gid://shopify/Product/12345`
 * @returns [data, error] — error is set when the product can't be loaded (a
 *   failed request, or no such product), for callers that need to tell "still
 *   loading" apart from "never arriving".
 */
export default function useProduct(id) {
  // Only a re-render trigger; the product is read from the cache below. Holding
  // it in state would leave the previous id's product there for the render in
  // which `id` changes, flashing it at callers that swap between two products.
  const [, setResolved] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id || getCachedProduct(id)) return;

    fetchProduct(id)
      .then((product) =>
        product
          ? setResolved(product)
          : setError(new Error(`No product ${id}`)),
      )
      .catch(setError);
  }, [id]);

  return [id ? getCachedProduct(id) : null, error];
}
